import { PaymentMethodVariant } from '../../types/payments'

/**
 * Способы оплаты, по которым клиент подписывает заявку в банке и попадает в период охлаждения
 * (50–200 тыс. ₽ — 4 часа, свыше 200 тыс. ₽ — 48 часов).
 * ВсегдаДА / Сбер Кредит / ТБанк Кредит приходят опциями внутри CREDIT и INSTALLMENT.
 */
const COOLING_OFF_PAYMENT_CODES: PaymentMethodVariant[] = ['CREDIT', 'INSTALLMENT', 'SPLIT', 'DOLYAME']

/** Сумма заказа (товары + доставка), с которой начинается период охлаждения */
export const COOLING_OFF_MIN_ORDER_PRICE = 50_000

export const isCoolingOffPayment = (code?: PaymentMethodVariant | null) =>
	!!code && COOLING_OFF_PAYMENT_CODES.includes(code)
